
































import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class QShareCode extends Vue {
  @Prop() readonly shareCode!: string
  @Prop() readonly label!: string

  showSuccess = false

  copy() {
    navigator.clipboard.writeText(this.shareCode)
    this.showSuccess = true
  }
}
